import {mapMutations} from "vuex";

export const showOverlay = {
  methods: {
    ...mapMutations({
      showOverlay: 'popups/SHOW_OVERLAY',
    })
  }
}
